import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import FormER from './FormER'
import SuccesfulTurn from './SuccessfulTurn'
import { showLoader, hideLoader } from '../../actions'
import { useBack } from '../../components/ui/layout/layoutMobile/BackContext'
import useFirebaseNotifications from '../../hooks/useFirebaseNotification'

const EmergencyRoom = (props) => {
	const { showLoader, hideLoader } = props
	const [submitedTurn, setSubmitedTurn] = useState({ isSubmited: false, speciality: null, clinic: null })
	const { setBackHandler } = useBack()

  const clear = () => {
    setSubmitedTurn({ isSubmited: false, speciality: null, clinic: null })
  }

	useFirebaseNotifications()

	useEffect(() => {
		if (submitedTurn.isSubmited || submitedTurn.speciality !== null) {
			setBackHandler(() => {
				if (submitedTurn.isSubmited) {
					clear()
				} else {
					setSubmitedTurn(prev => ({ ...prev, speciality: null, clinic: null }))
				}
			})
		} else {
			setBackHandler(null)
		}
	}, [submitedTurn.isSubmited, submitedTurn.speciality])

	return (
		<div style={{ width: '100%' }}>
			{submitedTurn.isSubmited ? (
				<SuccesfulTurn data={submitedTurn} clear={clear} />
			) : (
				<FormER setSubmitedTurn={setSubmitedTurn} submitedTurn={submitedTurn} {...props} showLoader={showLoader} hideLoader={hideLoader} clear={clear} />
			)}
		</div>
	)
}

const mapDispatchToProps = {
  showLoader,
  hideLoader
}

export default connect(
  null,
  mapDispatchToProps
)(EmergencyRoom)
